
<template>
  <div id="menuTopBar" class="layout-topbar">
    <button id="toggle-sidebar" class="p-link layout-menu-button" @click="onMenuToggle">
      <span style="font-size: 24px;" class="pi pi-bars"></span>
    </button>
    <div id="topbarIcon" class="layout-topbar-icons">
      <!-- <button id="btnNoti" class="p-link" @click="toggleNoti">
        <span class="layout-topbar-item-text">Notification</span>
        <BellRingOutline :value="countNotiUnread"/>
      </button> -->
      <OverlayPanel ref="notiOp" appendTo="body" class="mt-3" id="overlay_panel_noti" style="max-width: 600px;">
        <div class="noti-header justify-content-between">
          <div class="noti-header-title">Nhắc nhở</div>
          <span class="p-dialog-header-close-icon pi pi-times mr-3" @click="toggleNoti"></span>
        </div>
        <div class="noti-box" v-if="notis.length > 0">
          <div class="noti-items" @click="readNoti(item)" :class="{unread: !item.is_read, noborder: index == (notis.length-1) && notis.length >= totalNotis}" v-for="(item, index) in notis" :key="item.id" :id="`noti-${item.id}`">
            <div class="items-title" v-html="item.notification.title"></div>
            <div class="items-date">{{ item.notification.updated_at | formatDateTime}}</div>
            <div class="items-icon" @click.stop="delNoti(item, index)"><span class="pi pi-trash p-button-icon"></span></div>
          </div>
          <div class="noti-link-loadmore" v-if="notis.length < totalNotis">
              <span v-if="!loadingLoadMore" class="loadmore" @click="loadmoreNoti()">Xem thêm <span class="pi pi-angle-down"></span></span>
              <span v-else class="loadmore">Đang tải dữ liệu...</span>
          </div>
        </div>
        <div v-else class="noti-box box-empty">
          <div>Không có nhắc nhở</div>
        </div>
      </OverlayPanel>
      
      <!-- <button id="btnProfile" class="p-link">
        <span class="layout-topbar-item-text">Setting</span>
        <span style="font-size: 24px;" class="layout-topbar-icon fa fa-gear"></span>
      </button> -->
      
      <button id="btnProfile" class="p-link" @click="OnShow">
        <span class="layout-topbar-item-text">Người dùng</span>
        <!-- <span style="font-size: 24px;" class="layout-topbar-icon fa fa-user"></span> -->
        <Avatar icon="pi pi-user" class="mr-2" style="background-color:#d6f2ff; color: #0086C4; width: 27px; height: 27px;" shape="circle" />
        <span>{{ $store.getters.fullname ?? "HSE USER" }}</span>
      </button>
      <OverlayPanel ref="op" appendTo="btnProfile" class="mt-3" id="overlay_panel" style="width:150px">
        <div class="">
          <a href="#" title="Đổi mật khẩu"  @click='openChangePassword()'>
            <div class="fontsize">Đổi mật khẩu</div>
          </a>
        </div>
        <hr class="new1" />
        <div>
          <a href="#" @click='submitLogout' class="fontsize" title="Đăng xuất">Đăng xuất</a>
        </div>
      </OverlayPanel>
    </div>
    <Dialog header="ĐĂNG XUẤT" :visible.sync="displayLogout" :style="{width: '600px','text-align': 'left'}" :modal="true" :position="position">
      <div class="confirmation-content">
          <span>Bạn có chắc muốn đăng xuất khỏi tài khoản này không?</span>
      </div>
      <template #footer>
        <div class="custom-center">
          <Button label="Hủy" @click="closeLogout()" icon="pi pi-times" class="btn-cancel" />
          <Button label="Xác nhận" @click="validateLogout()" icon="pi pi-check" class="btn-save mr-0" autofocus="autofocus" />
          <!-- <button @click="closeLogout()" class="btn btn-cancel"> Huỷ</button>
          <button @click="validateLogout()" class="btn btn-save mr-0" autofocus><i class="pi pi-check icon" style="font-size: 15px; "></i> Xác nhận</button>  -->
        </div>
      </template>
    </Dialog>

    <Dialog header="ĐỔI MẬT KHẨU" :visible.sync="displayChangePassword" :style="{width: '600px'}" :modal="true" :position="position">
      <div class="confirmation-content">
        <span class="" style="color:red" v-if='error'> {{error}}</span>
          <form action="#" autocomplete="off">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group custom-form-group" style="position: relative">
                  <label class="control-label">Mật khẩu hiện tại</label>
                  <input id="passwordOld" placeholder="Nhập" v-model="passwordOld" :type='passwordType' required="required" class="form-control form-custom-pass custom-pass-input" style="padding-right: 40px !important;margin-bottom: 16px;">
                  <i style="margin-top: -45px; cursor: pointer;" class="material-icons lg-icon-password" @click="switchVisibility" v-if="passwordType === 'text'">visibility</i>
                  <i style="margin-top: -45px; cursor: pointer;" class="material-icons lg-icon-password" @click="switchVisibility" v-else>visibility_off</i>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group custom-form-group" style="position: relative;">
                  <label class="control-label">Mật khẩu mới</label>
                  <input id="passwordNew" placeholder="Nhập" v-model="passwordNew" :type='secondPasswordType' @keyup='checkPassword' required="required" class="form-control form-custom-pass custom-pass-input" style="padding-right: 40px !important;margin-bottom: 16px;">
                  <i style="margin-top: -45px; cursor: pointer;" class="material-icons lg-icon-password" @click="switchVisibilityNew" v-if="secondPasswordType === 'text'">visibility</i>
                  <i style="margin-top: -45px; cursor: pointer;" class="material-icons lg-icon-password" @click="switchVisibilityNew" v-else>visibility_off</i>
                </div>
              </div>
            <div class="col-md-12">
              <div class="form-group custom-form-group" style="position: relative; margin-bottom: 0;">
                <label class="control-label">Nhập lại mật khẩu</label>
                <input id="passwordConfirm" placeholder="Nhập" v-model="passwordConfirm" :type='confirmPasswordType' @keyup='checkPassword' required="required" class="form-control form-custom-pass custom-pass-input" style="padding-right: 40px !important;">
                <i style="cursor: pointer;" class="material-icons lg-icon-password" @click="switchVisibilityConfirm" v-if="confirmPasswordType === 'text'">visibility</i>
                <i style="cursor: pointer;" class="material-icons lg-icon-password" @click="switchVisibilityConfirm" v-else>visibility_off</i>
              </div>
            </div>
          </div>
        </form>
      </div>
      <template #footer>
        <div class="custom-center">
          <Button label="Hủy" @click="displayChangePassword = false" icon="pi pi-times" class="btn-cancel" />
          <Button label="Lưu thay đổi" @click="submitChangePassword()" icon="pi pi-check" class="btn-save mr-0" autofocus="autofocus" />
        </div>
      </template>
      <!-- <Dialog :visible.sync="displayChangePassword" :modal="true" :position="position"> -->
        <!-- <changePassword :visible.sync="displayChangePassword" class="modal" :position="position"/> -->
      <!-- </Dialog> -->
    </Dialog>
    
    <Dialog :visible.sync="displayRemoveNoti" id="removeNotiPopup" :containerStyle="{width: '50vw'}">
      <template #header>
        <span v-html="removeNotiTitle"></span>
      </template>
      <p class="m-0">Bạn có chắc muốn xoá thông báo này không?</p>
      <template #footer>
          <Button label="Hủy" icon="pi pi-times" @click="displayRemoveNoti = false" class="btn-cancel"/>
          <Button label="Xóa" icon="pi pi-check" @click="confirmDel" autofocus class="btn btn-danger" />
      </template>
    </Dialog>
  </div>
</template>

<script>
// import BellRingOutline from 'vue-material-design-icons/BellRingOutline.vue';
import ApiRepository from "@/core/ApiRepository";
// import BellRingOutline from "@/components/icons/Notification";
import moment from "moment-timezone";
// import store from '../../../store';
//import firebase from 'firebase'
// import changePassword from '@/views/auth/changePassword.vue'
import Cryptojs from 'crypto-js'
import { useWebNotification } from '@vueuse/core';
export default {
  components: {
    // 'changePassword': changePassword,
    // BellRingOutline,
  },
  computed: {
    countNotiUnread(){
      const notis = this.notis.filter(f => !f.is_read)
      return notis.length;
    }
  },
  async created() {
    await this.getListNotification();
  },
  async mounted() {
    // this.$messaging.onMessage(async (payload) => {
    //   // console.log('Message received. ', payload);
    //     var options = {
    //       title: payload?.notification?.title,
    //       dir: "auto",
    //       lang: "vi",
    //       renotify: true,
    //       silent: false,
    //       icon: "../../../assets/layout/images/logo.png",
    //       tag: "hse"
    //     }
    //     await this.pushNotification(options);
    // });
  },
  data() {
    return {
      show: false,
      displayLogout: false,
      passwordOld: null,
      passwordNew: null,
      passwordConfirm: null,
      passwordType: 'password',
      secondPasswordType: 'password',
      confirmPasswordType: 'password',
      displayChangePassword: false,
      error: null,
      position : 'top',
      loadingLoadMore: false,
      removeNotiTitle: "",
      displayRemoveNoti: false,
      removeNotiId: null,
      removeNotiIndex: null,
      fullname: null,
      time_zone_local : moment.tz.guess(true),
      totalNotis: 0,
      notis: [],
      limit: 20,
      offset: 0,
    }
  },
  methods: {
    async pushNotification(options) {
      const { isSupported, show, onShow } = useWebNotification(options);
      if (isSupported.value) {
        show();
        onShow(async () => {
          this.offset = 0;
          await this.getListNotification();
        })
      }
    },

    async getListNotification() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/notification/list", {limit: this.limit, offset: this.offset}, {headers}).then(function (response) {
            var data = response.data.data;
            var newData = null;
            if (that.offset > 0) {
              newData = data.notifications.map(m => {
                var title = m.title;
                if (m.object_name) {
                    title = title.replace("#OBJECT_NAME#", m.object_name);
                }

                if (m.object_name_2) {
                    title = title.replace("#OBJECT_NAME_2#", m.object_name_2);
                }
                m.title = title;
                return m;
              })
              that.notis.push(...newData);
            } else {
              newData = data.notifications.map(m => {
                var title = m.notification.title;
                if (m.notification.object_name) {
                    title = title.replace("#OBJECT_NAME#", m.notification.object_name);
                }

                if (m.notification.object_name_2) {
                    title = title.replace("#OBJECT_NAME_2#", m.notification.object_name_2);
                }
                m.notification.title = title;
                return m;
              })
              that.notis = newData;
            }
            that.totalNotis = data.count;
            that.loadingLoadMore = false;
        }).catch((err)=> {
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
        })
      }
    },
    async loadmoreNoti() {
      this.loadingLoadMore = true;
      if (this.notis.length < this.totalNotis) {
        this.offset = this.notis.length;
        await this.getListNotification();
      } else {
        this.loadingLoadMore = false;
      }
    },
    // async loadNoti() {
    //   this.notisLoad.map(async m => {
    //     var id = await this.$commonFuction.generateUUID();
    //     var tmp = Object.assign({id: id}, m);
    //     this.notis.push(tmp);
    //   })
    // },
    async delNoti(data, index) {
      this.displayRemoveNoti = true;
      this.removeNotiTitle = data.notification.title;
      this.removeNotiIndex = index;
      this.removeNotiId = data.notification_id;
      this.toggleNoti();
    },

    async confirmDel() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/notification/delete", {id: this.removeNotiId}, {headers}).then(function () {
          that.notis.splice(that.removeNotiIndex, 1);
          that.displayRemoveNoti = false;
          that.removeNotiTitle = "";
          that.removeNotiIndex = null;
          that.removeNotiId = null;
          that.$toast.add({
            severity: 'success',
            summary: "Thành công",
            detail: `Xóa thông báo thành công`,
            life: 3000
          });
        }).catch((err)=> {
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
        })
      }
    },

    async readNoti(data) {
      if (!data.is_read) {
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = {
            "Authorization": "Bearer "+token,
          };
          var that = this;
          await ApiRepository.post("/_api/notification/read", {id: data.id}, {headers}).then(function () {
            data.is_read = true;
            if (data?.notification?.object_id && data?.notification?.type) {
              if (data?.notification?.webview_url) {
                that.$router.push(data?.notification?.webview_url);
              } else {
                if (["MEASURES", "EVALUATION"].includes(data?.notification?.type)) {
                  // window.location.href = `/admin/evaluation-form/detail/${data?.notification?.object_id}`;
                  that.$router.push({path: `/admin/evaluation-form`});
                  setTimeout(() => {
                    that.$router.push({path: `/admin/evaluation-form/detail/${data?.notification?.object_id}`});
                  }, 100);
                } else if (["HISTORY_MEASURES"].includes(data?.notification?.type)) {
                  // window.location.href = `/admin/control_measures/history?company_id=${this.$store.getters.company_id}&cm_id=${data?.notification?.object_id}`;
                  that.$router.push({path: `/admin/control_measures`}).catch((er) => {
                    console.log(er);
                  });
                  setTimeout(() => {
                    that.$router.push({path: `/admin/control_measures/history`, query: {cm_id: data?.notification?.object_id, company_id: that.$store.getters?.company_id}}).catch((er) => {
                      console.log(er);
                    });
                  }, 100);
                } else if (["SRA"].includes(data?.notification?.type)) {
                  // window.location.href = `/admin/control_measures/history?company_id=${this.$store.getters.company_id}&cm_id=${data?.notification?.object_id}`;
                  that.$router.push({path: `/admin/list-sra`}).catch((er) => {
                    console.log(er);
                  });
                  setTimeout(() => {
                    that.$router.push({path: `/admin/list-sra/view/`+data?.notification?.object_id, query: {company_id: that.$store.getters?.company_id}}).catch((er) => {
                      console.log(er);
                    });
                  }, 100);
                } else if (["ATW"].includes(data?.notification?.type)) {
                  // window.location.href = `/admin/control_measures/history?company_id=${this.$store.getters.company_id}&cm_id=${data?.notification?.object_id}`;
                  that.$router.push({path: `/admin/list-atw`}).catch((er) => {
                    console.log(er);
                  });
                  setTimeout(() => {
                    that.$router.push({path: `/admin/list-atw/view/`+data?.notification?.object_id, query: {company_id: that.$store.getters?.company_id}}).catch((er) => {
                      console.log(er);
                    });
                  }, 100);
                } else if (["DATW"].includes(data?.notification?.type)) {
                  // window.location.href = `/admin/control_measures/history?company_id=${this.$store.getters.company_id}&cm_id=${data?.notification?.object_id}`;
                  that.$router.push({path: `/admin/daily-atw`}).catch((er) => {
                    console.log(er);
                  });
                  setTimeout(() => {
                    that.$router.push({path: `/admin/daily-atw/view/`+data?.notification?.object_id, query: {company_id: that.$store.getters?.company_id}}).catch((er) => {
                      console.log(er);
                    });
                  }, 100);
                } else {
                  // window.location.href = `/admin/${data.type}/detail/${data?.notification?.object_id}`;
                  that.$router.push({path: `/admin/${data.type}`});
                  setTimeout(() => {
                    that.$router.push({path: `/admin/${data.type}/detail/${data?.notification?.object_id}`});
                  }, 100);
                }
              }
            }
          }).catch((err)=> {
            that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            });
          })
        }
      } else {
        if (data?.notification?.object_id && data?.notification?.type) {
          console.log("data?.notification?.type", data?.notification?.type);
          if (data?.notification?.webview_url) {
            this.$router.push(data?.notification?.webview_url);
          } else {
            if (["MEASURES", "EVALUATION"].includes(data?.notification?.type)) {
              // window.location.href = `/admin/evaluation-form/detail/${data?.notification?.object_id}`;
              this.$router.push({path: `/admin/evaluation-form`});
              setTimeout(() => {
                this.$router.push({path: `/admin/evaluation-form/detail/${data?.notification?.object_id}`});
              }, 100);
            } else if (["HISTORY_MEASURES"].includes(data?.notification?.type)) {
              // window.location.href = `/admin/control_measures/history?company_id=${this.$store.getters.company_id}&cm_id=${data?.notification?.object_id}`;
              this.$router.push({path: `/admin/control_measures`}).catch((er) => {
                console.log(er);
              });
              setTimeout(() => {
                this.$router.push({path: `/admin/control_measures/history`, query: {cm_id: data?.notification?.object_id, company_id: this.$store.getters?.company_id}}).catch((er) => {
                  console.log(er);
                });
              }, 100);
            } else if (["SRA"].includes(data?.notification?.type)) {
              // window.location.href = `/admin/control_measures/history?company_id=${this.$store.getters.company_id}&cm_id=${data?.notification?.object_id}`;
              this.$router.push({path: `/admin/list-sra`}).catch((er) => {
                console.log(er);
              });
              setTimeout(() => {
                this.$router.push({path: `/admin/list-sra/view/`+data?.notification?.object_id, query: {company_id: this.$store.getters?.company_id}}).catch((er) => {
                  console.log(er);
                });
              }, 100);
            } else if (["ATW"].includes(data?.notification?.type)) {
              // window.location.href = `/admin/control_measures/history?company_id=${this.$store.getters.company_id}&cm_id=${data?.notification?.object_id}`;
              this.$router.push({path: `/admin/list-atw`}).catch((er) => {
                console.log(er);
              });
              setTimeout(() => {
                this.$router.push({path: `/admin/list-atw/view/`+data?.notification?.object_id, query: {company_id: this.$store.getters?.company_id}}).catch((er) => {
                  console.log(er);
                });
              }, 100);
            } else if (["DATW"].includes(data?.notification?.type)) {
              // window.location.href = `/admin/control_measures/history?company_id=${this.$store.getters.company_id}&cm_id=${data?.notification?.object_id}`;
              this.$router.push({path: `/admin/daily-atw`}).catch((er) => {
                console.log(er);
              });
              setTimeout(() => {
                this.$router.push({path: `/admin/daily-atw/view/`+data?.notification?.object_id, query: {company_id: this.$store.getters?.company_id}}).catch((er) => {
                  console.log(er);
                });
              }, 100);
            } else {
              // window.location.href = `/admin/${data.type}/detail/${data?.notification?.object_id}`;
              this.$router.push({path: `/admin/${data.type}`});
              setTimeout(() => {
                this.$router.push({path: `/admin/${data.type}/detail/${data?.notification?.object_id}`});
              }, 100);
            }
          }
        }
      }
    },
    toggleNoti(event) {
      this.$refs.notiOp.toggle(event);
    },
    onMenuToggle(event) {
      this.$emit('menu-toggle', event);
    },
    OnShow(event) {
      this.$refs.op.toggle(event);
    },
    submitLogout() {
      this.displayLogout = true;
      // this.$modal.show(mdLogout, {}, {
      //   clickToClose: false,
      //   height: 'auto',
      //   adaptive: true,
      //   classes: ['col-md-6'],
      //   reset: true
      // })
    },
    closeLogout() {
      this.displayLogout = false;
    },
    closeChangePassword() {
      this.displayChangePassword = false;
    },
    openChangePassword() {
      // close pop-up edit profile
      //this.$emit('close')
      this.error = null;
      this.passwordOld = null;
      this.passwordNew = null;
      this.passwordConfirm = null;
      this.displayChangePassword = true;
      try {
        this.displayChangePassword = true;
      } catch (e) {
        console.error(e)
      }
    },
    validateLogout() {
      // console.log('Logout')
      this.$AuthenticationApp.clearDataLogout().then(() => {
        //this.$emit('close')
        this.displayLogout = false;
        //this.$router.push('/auth/login')
      })
    },
    switchVisibility() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    switchVisibilityNew() {
      this.secondPasswordType = this.secondPasswordType === 'password' ? 'text' : 'password'
    },
    switchVisibilityConfirm() {
      this.confirmPasswordType = this.confirmPasswordType === 'password' ? 'text' : 'password'
    },
    checkPassword() {
      // console.log(e)
      if (this.passwordConfirm !== this.passwordNew) {
        this.matched = false
      } else {
        this.matched = true
      }
    },
    async submitChangePassword() {
      var that = this;
      if (!this.$commonFuction.isEmpty(this.passwordConfirm)
          && !this.$commonFuction.isEmpty(this.passwordOld)
          && !this.$commonFuction.isEmpty(this.passwordNew)
      ) {
        if (this.matched == false){
          this.error = 'New password does not match.';
          return false;
        }
        //console.log("await this.getStateLogin()",(await this.$AuthenticationApp.getToken()))
        const headers = {
          "Authorization": "Bearer "+(await this.$AuthenticationApp.getToken()),
        };
        that.$commonFuction.is_loading(true);
        var dataChangePassword = {
          password_current: (Cryptojs.SHA256(this.passwordOld.toString())).toString() ,
          password_new: (Cryptojs.SHA256(this.passwordNew.toString())).toString() ,
        }
        ApiRepository.post(this.$constants.API.CHANGE_PASSWORD, dataChangePassword, {headers}).then(async (res) => {
          console.log('=========> createUser: ', res)
          that.$toast.add({severity: 'success', summary: 'Success', detail: 'Change password successfully', life: 3000});
          that.$commonFuction.is_loading(false);
          that.displayChangePassword = false;
          //logout ra
          that.$AuthenticationApp.clearDataLogout().then(() => {
            this.$router.push('/auth/login')
          })
        })
            .catch(async error => {
              //this.errorMessage = error.message;
              var message = error.response.data.message;
              //console.error("There was an error!", message);
              switch(message) {
                case that.$constants.MSG_ERROR.INVALID_TOKEN_ERR:
                  that.$toast.add({
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: that.$constants.MSG_TEXT.SESION_LOGIN_EXPIRED,
                    life: 3000
                  });
                  await that.$commonFuction.sleep(2000);
                  //logout
                  that.$AuthenticationApp.clearDataLogout().then(() => {})
                  that.$commonFuction.is_loading(false);
                  break;
                case that.$constants.MSG_ERROR.MISMATCH_PARAMS_ERR:
                  that.$toast.add({
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                  that.$commonFuction.is_loading(false);
                  break;
                case that.$constants.MSG_ERROR.INVALID_CURRENT_PASSWORD_ERR:
                  that.$toast.add({
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: that.$constants.MSG_TEXT.INVALID_CURRENT_PASSWORD_ERR,
                    life: 3000
                  });
                  that.$commonFuction.is_loading(false);
                  break;
                case that.$constants.MSG_ERROR.PASSWORD_NEW_NOT_SAME_PASSWORD_CURRENT_ERR:
                  that.$toast.add({
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: that.$constants.MSG_TEXT.PASSWORD_NEW_NOT_SAME_PASSWORD_CURRENT_ERR,
                    life: 3000
                  });
                  that.$commonFuction.is_loading(false);
                  break;
                default:
                  that.$toast.add({
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                  that.$commonFuction.is_loading(false);
              }
            });
      } else  {
        // console.log(this.$refs)
        this.error = 'Vui lòng điền đầy đủ thông tin!'
      }
    }
  },
  filters: {
    formatDateTime: function (value) {
      var time_zone_local = moment.tz.guess(true);
      var newValue = null
      if (!value) return newValue
      if (moment.tz(value, time_zone_local).format("DD/MM/yyyy") == moment.tz(new Date(), time_zone_local).format("DD/MM/yyyy")) {
        newValue = moment.tz(value, time_zone_local).format("HH:mm");
      } else if (moment.tz(value, time_zone_local).format("yyyy") == moment.tz(new Date(), time_zone_local).format("yyyy")) {
        newValue = moment.tz(value, time_zone_local).format('DD [thg] MM');
      } else {
        newValue = moment.tz(value, time_zone_local).format("DD/MM/yyyy");
      }
      return newValue;
    }
  }
}
</script>
<style lang="scss">
.fontsize {
  font-size: 13px;
}
#overlay_panel {
  top: 15px !important;
  left: unset !important;
  right: 0 !important;
}
.form-custom-pass{
  padding-right: 40px !important;
  padding-right: 42.5px;
  border-radius: 3px !important;
  box-shadow: none;
  border-color: #d2d6de;
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  font-family: inherit;
}
.lg-icon-password {
    margin-top: -30px;
    display: block;
    position: absolute;
    right: 10px;
    bottom: 10px;
}
.custom-pass-input{
  margin-top: 2px;
}
.default-custom-btn{
  width: 125px !important;
}
.custom-center{
  text-align: center;
}
.p-dialog-header{
  padding: 16px 24px !important;
  .p-dialog-title{
    font-weight: bold;
    font-size: 18px;
    color: #1D3118;
  }

  background-color: #F4F4F4 ;
  border-bottom: 1px solid #C8C8C8;
}

.p-dialog-content{
  padding: 24px !important;
  border-bottom: 1px solid #D0D4D9;
  .control-label{
    font-weight: bold;
    font-size: 16px;
    color: #333333;
  }
  .form-control{
    height: 48px;
  }
}

.p-dialog-footer{
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px !important;
  .btn-cancel{
    background-color: #F2F3F7;
    border: unset;
    color: #333333;
    .p-button-label{
      color: #333333 !important;
    }
    text-transform: none;
    font-size: 16px;
    // font-family: 'adobe clean', sans-serif;
    border-radius: 3px;
    padding-left: 16px;
    padding-right: 16px;
    width: auto;
    margin-top: 0 !important;
    height: 40px;
    letter-spacing: 0;
    &:hover{
      color: #333333;
      background-color: #F2F3F7;
    }
  }
  .btn-save{
    background-color: #0086C4;
    color: #FFFFFF;
    text-transform: none;
    font-size: 16px;
    // font-family: 'adobe clean', sans-serif;
    border-radius: 3px;
    padding-left: 16px;
    padding-right: 16px;
    width: auto;
    margin-top: 0 !important;
    height: 40px;
    letter-spacing: 0;
    border: unset;
    &:hover{
      color: white;
      background-color: #0086C4;
    }
  }
}
.p-overlaypanel-content{
  padding: 16px !important;
  a {
    color: #333333;
  }
  hr {
    opacity: 0.5;
    background: #EEEEEE;
    height: 1px;
  }
}
.p-dialog-mask.p-dialog-top.p-component-overlay{
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 311px){
  .p-dialog-footer{
    flex-direction: column !important;
    justify-content: end !important;
    align-items: end !important;
    .custom-center{
      text-align: end !important;
    }
    .btn-cancel{
      margin-bottom: 10px !important;
      margin-right: 0px !important;
    }
  }
}
.noti-box {
  width: 100%;
  max-height: 400px;
  overflow: auto;
}
.box-empty {
  text-align: center;
}
.noti-items {
  display: flex;
  border-bottom: 1px solid #eee;
  padding: 15px 0;
  cursor: pointer;
}
.noti-items.unread .items-title {
  color:#0086C4;
  font-weight: bold;
}
.noti-items.unread .items-title::before{
  content: "";
  border-radius: 50%;
  background-color: #0086C4;
  width: 10px;
  height: 10px;
  position: absolute;
  left: 0%;
  top: 15%;
}
.noti-items .items-title{
  flex-basis: 75%;
  padding-left: 20px;
  position: relative;
}
.noti-items .items-date {
  flex-basis: 20%;
  text-align: right;
}
.noti-items .items-icon{
  flex-basis: 5%;
  text-align: right;
}
.noti-items .items-icon:hover {
  color: #c82333 !important;
}
.noti-link-loadmore {
  color: #0086C4;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  .loadmore {
    cursor: pointer;
  }
}
.noti-header {
  height: 50px;
  background-color: #F4F4F4;
  display: flex;
  align-items: center;
  .noti-header-title {
    flex-basis: 90%;
    padding: 0.571rem 1rem;
    font-weight: bold;
    color: #1D3118;
    font-size: 18px;
  }
  .pi.pi-times {
    cursor: pointer;
  }
}
#overlay_panel_noti .p-overlaypanel-content{
  padding: 0 !important;
  padding-bottom: 23px !important;
  .noti-box {
    padding: 0.571rem 1rem;
  }
}
#overlay_panel_noti {
  // z-index: 998 !important;
  position: fixed;
  display: block !important;
  top: 2em !important;
  right: 0 !important;
  width: 600px;
}
.p-dialog-mask, #removeNotiPopup {
  z-index: 2000 !important;
}

#removeNotiPopup .btn-danger:hover {
    color: #fff;
    background-color: #c82333 !important;
    border-color: #bd2130 !important;
}
.noborder {
  border: unset !important;
}

@media (max-width: 789px) {
  #overlay_panel_noti {
    width: auto !important;
  }
}
</style>